import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { navLinks } from '../../utils/Data.js';

import {
  NavMenuContainer,
  CloseIcon,
  MenuItem,
} from '../../styles/Navbar.styled.js';

function NavMenu({ setOpenMenu, activeSection }) {
  return (
    <NavMenuContainer>
      <CloseIcon onClick={() => setOpenMenu(false)} aria-label="Close menu">
        <AiOutlineClose />
      </CloseIcon>

      {navLinks.map((link) => (
        <MenuItem
          key={link.id}
          href={`#${link.href}`}
          active={activeSection === link.href}
          aria-current={activeSection === link.href ? 'page' : undefined}
          onClick={() => setOpenMenu(false)}
        >
          {link.name}
        </MenuItem>
      ))}
    </NavMenuContainer>
  );
}

export default NavMenu;
